import { MobileCardField, MobileFieldsGrid } from '@/shared/design-system';
import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

import { MobileCardList } from '../my-assets/mobile-card-list';
import { PerformancePositionSelectionIcon } from '../performance-position-selection-icon';
import { fmtAmount, fmtUsd } from './formatters';
import { RowActions } from './row-actions';
import { CryptoPerformanceSelection } from './types';

interface CryptoAssetsMobileProps {
  assets: CryptoAsset[];
  sortedAssets: CryptoAsset[];
  activePositionId?: string;
  suiAddress: string | undefined;
  onSelectPosition: (_selection: CryptoPerformanceSelection | null) => void;
}

export const CryptoAssetsMobile = ({
  assets,
  sortedAssets,
  activePositionId,
  suiAddress,
  onSelectPosition,
}: CryptoAssetsMobileProps) => (
  <MobileCardList
    items={sortedAssets.map((coin) => ({
      value: coin.coinType,
      title: coin.symbol,
      startIcon: coin.positionId ? (
        <PerformancePositionSelectionIcon
          active={coin.positionId === activePositionId}
          dimmed={Boolean(activePositionId) && coin.positionId !== activePositionId}
        />
      ) : undefined,
      content: (
        <>
          <MobileFieldsGrid>
            <MobileCardField label="Amount" value={fmtAmount(coin.balance)} />
            <MobileCardField label="Cost Basis" value={fmtUsd(coin.costBasisInUsd)} />
            <MobileCardField label="Present Value" value={fmtUsd(coin.usdValue)} />
          </MobileFieldsGrid>
          <RowActions coin={coin} assets={assets} suiAddress={suiAddress} />
        </>
      ),
    }))}
    defaultValue={sortedAssets[0]?.coinType ?? null}
    onValueChange={(coinType) => {
      if (coinType === null) {
        if (activePositionId) onSelectPosition(null);
        return;
      }
      const coin = sortedAssets.find((asset) => asset.coinType === coinType);
      if (coin?.positionId) onSelectPosition({ id: coin.positionId, name: coin.symbol });
    }}
    emptyMessage={
      suiAddress
        ? 'No crypto assets found for this wallet.'
        : 'Connect a wallet to view crypto assets.'
    }
  />
);
